import publisherAPIInstance from "./publisherApiInstance";

const publishingTemplatesAPIs = {
  listTemplate: ({ payload }) => publisherAPIInstance.post(`/api/v1/template.list`, payload),
  createTemplate: ({ payload }) => publisherAPIInstance.post(`/api/v1/template.create`, payload),
  updateTemplate: ({ payload }) => publisherAPIInstance.post(`/api/v1/template.update`, payload),
  deleteTemplate: ({ payload }) => publisherAPIInstance.post(`/api/v1/template.delete`, payload),
  getTemplateVariables: ({ payload }) => publisherAPIInstance.post(`/api/v1/template.variables`, payload),
  getTemplateVariableList: ({ payload }) => publisherAPIInstance.post(`/api/v1/template.listVariables`, payload),
  getTemplate: ({ payload }) => publisherAPIInstance.post(`/api/v1/template.get`, payload),
};

export default publishingTemplatesAPIs;
